<div class="status-dialog-container">
    <div class="dialog-header">
        <div class="header-content">
            <i class="pi pi-sync header-icon"></i>
            <div class="header-text">
                <h2>Update Work Order Status</h2>
                <span class="quotation-reference">#{{quotationNo}}</span>
            </div>
        </div>
    </div>

    <div class="dialog-content">
        <!-- Workflow Progress Section -->
        <div class="progress-section">
            <div class="progress-header">
                <div class="status-indicator">
                    <i class="pi pi-chart-line"></i>
                    <span>Current Status: <strong>{{getStatusLabel(status) || 'Not started'}}</strong></span>
                </div>
                <div class="progress-indicator">
                    <span class="progress-value">{{progressValue | number:'1.0-0'}}%</span>
                    <span>complete</span>
                </div>
            </div>

            <div class="progress-bar-container">
                <p-progressBar [value]="progressValue" [showValue]="false" class="animated-progress"></p-progressBar>
                <div class="progress-steps">
                    <div *ngFor="let step of availableStatuses; let i = index" class="step-marker"
                        [class.active]="i <= activeIndex" [class.current]="i === activeIndex"
                        [title]="step.label + ': ' + step.description">
                        <i [class]="'pi ' + step.icon"></i>
                        <span class="step-label">{{step.label}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Status Selection Section -->
        <div class="status-selection">
            <label for="status" class="selection-label">
                <i class="pi pi-arrow-right-arrow-left"></i>
                Update Status
            </label>
            <p-dropdown id="status" [(ngModel)]="status" [options]="availableStatuses" optionLabel="label"
                optionValue="value" placeholder="Select new status" [showClear]="false" appendTo="body"
                (onChange)="onStatusChange()">
                <ng-template let-status pTemplate="item">
                    <div class="status-option">
                        <i [class]="'pi ' + status.icon"></i>
                        <div class="option-details">
                            <span class="option-label">{{status.label}}</span>
                            <span class="option-description">{{status.description}}</span>
                        </div>
                    </div>
                </ng-template>
            </p-dropdown>

            <div class="status-description" *ngIf="status">
                <i class="pi pi-info-circle"></i>
                <div class="description-text">
                    <h4>{{getStatusLabel(status)}}</h4>
                    <p>{{getStatusDescription(status)}}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
        <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-outlined p-button-secondary"
            (click)="cancel()"></button>
        <button pButton type="button" label="Update Status" icon="pi pi-check" class="p-button-raised"
            [class]="'status-button-' + activeIndex" (click)="saveStatus()" [loading]="loading"
            [disabled]="!status"></button>
    </div>
</div>

<p-toast position="top-center"></p-toast>